document.addEventListener('DOMContentLoaded', function() {
  initPersonalizationEngine();
  initCartAddSafeguard();
});

function initCartAddSafeguard() {
  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (form && form.matches('form[action*="/cart/add"], form[data-type="add-to-cart-form"]')) {
      let idInput = form.querySelector('input[name="id"]');
      if (!idInput || !idInput.value || idInput.value.trim() === '' || idInput.value === 'null') {
        const fallbackInput = form.querySelector('.su-pers-wrapper input[name="id"]');
        if (fallbackInput && fallbackInput.value) {
          if (!idInput) {
            idInput = document.createElement('input');
            idInput.type = 'hidden';
            idInput.name = 'id';
            idInput.value = fallbackInput.value;
            form.appendChild(idInput);
          } else {
            idInput.value = fallbackInput.value;
            idInput.removeAttribute('disabled');
          }
        } else {
          const productDataEl = document.querySelector('xo-product-data script');
          if (productDataEl) {
            try {
              const pData = JSON.parse(productDataEl.textContent);
              if (pData.variants && pData.variants.length > 0) {
                if (!idInput) {
                  idInput = document.createElement('input');
                  idInput.type = 'hidden';
                  idInput.name = 'id';
                  idInput.value = pData.variants[0].id;
                  form.appendChild(idInput);
                } else {
                  idInput.value = pData.variants[0].id;
                  idInput.removeAttribute('disabled');
                }
              }
            } catch(err) {}
          }
        }
      }
    }
  }, true);

  const originalFetch = window.fetch;
  window.fetch = function() {
    const url = arguments[0];
    if (typeof url === 'string' && url.includes('/cart/add')) {
      const options = arguments[1] || {};
      if (options.body && typeof options.body === 'string') {
        try {
          const payload = JSON.parse(options.body);
          if (payload.items && payload.items.length > 0) {
            payload.items.forEach(item => {
              if (!item.id || item.id === '' || item.id === 'null') {
                const productDataEl = document.querySelector('xo-product-data script');
                if (productDataEl) {
                  const pData = JSON.parse(productDataEl.textContent);
                  if (pData.variants && pData.variants[0]) {
                    item.id = pData.variants[0].id;
                  }
                }
              }
            });
            options.body = JSON.stringify(payload);
          }
        } catch(err) {}
      }
    }
    return originalFetch.apply(this, arguments);
  };
}

function initPersonalizationEngine() {
  const toggleBtn = document.querySelector('.su-pers-toggle');
  const bodyContent = document.querySelector('.su-pers-body');

  if (toggleBtn && bodyContent) {
    toggleBtn.addEventListener('click', function(e) {
      e.preventDefault();
      const isOpen = toggleBtn.classList.contains('open');

      if (isOpen) {
        toggleBtn.classList.remove('open');
        bodyContent.classList.remove('active');
        toggleBtn.querySelector('.su-pers-toggle-text').textContent = '+ Upload Portrait Photo & Personal Message';
      } else {
        toggleBtn.classList.add('open');
        bodyContent.classList.add('active');
        toggleBtn.querySelector('.su-pers-toggle-text').textContent = '− Upload Portrait Photo & Personal Message';
      }
    });
  }

  // Live Counter for Personal Message / Instructions Textarea (150 chars limit)
  const instructionsTextarea = document.querySelector('#su-instructions-text');
  const instructionsCounter = document.querySelector('#su-instructions-counter');
  if (instructionsTextarea && instructionsCounter) {
    const maxCharsInst = parseInt(instructionsTextarea.getAttribute('maxlength') || '150', 10);
    instructionsTextarea.addEventListener('input', function() {
      instructionsCounter.textContent = `${instructionsTextarea.value.length}/${maxCharsInst}`;
    });
  }

  // File Uploader & Direct Cloud CDN Upload
  const fileInput = document.querySelector('#su-photo-file');
  const hiddenPhotoProp = document.querySelector('#su-prop-photo-name');
  const dropzone = document.querySelector('.su-file-dropzone');
  const previewBox = document.querySelector('.su-file-preview');
  const previewImg = document.querySelector('#su-preview-img');
  const previewName = document.querySelector('.su-file-preview-name');
  const previewSize = document.querySelector('.su-file-preview-size');
  const removeBtn = document.querySelector('.su-file-remove-btn');

  if (fileInput && dropzone) {
    fileInput.addEventListener('change', function() {
      const file = fileInput.files[0];
      if (!file) return;

      if (previewName) previewName.textContent = file.name + ' (Uploading...)';
      if (previewSize) previewSize.textContent = `${(file.size / (1024 * 1024)).toFixed(2)} MB`;

      const formData = new FormData();
      formData.append('UPLOADCARE_PUB_KEY', 'demopublickey');
      formData.append('UPLOADCARE_STORE', '1');
      formData.append('file', file);

      fetch('https://upload.uploadcare.com/base/', {
        method: 'POST',
        body: formData
      })
      .then(res => res.json())
      .then(data => {
        if (data && data.file) {
          const cdnUrl = `https://ucarecdn.com/${data.file}/${encodeURIComponent(file.name)}`;
          if (hiddenPhotoProp) hiddenPhotoProp.value = cdnUrl;
          if (previewName) previewName.textContent = file.name + ' ✓ Ready';
        } else {
          if (hiddenPhotoProp) hiddenPhotoProp.value = `Photo: ${file.name}`;
          if (previewName) previewName.textContent = file.name;
        }
      })
      .catch(err => {
        if (hiddenPhotoProp) hiddenPhotoProp.value = `Photo: ${file.name}`;
        if (previewName) previewName.textContent = file.name;
      });

      const reader = new FileReader();
      reader.onload = function(e) {
        if (previewImg) previewImg.src = e.target.result;
        if (dropzone) dropzone.style.display = 'none';
        if (previewBox) previewBox.style.display = 'flex';
      };
      reader.readAsDataURL(file);
    });

    if (removeBtn) {
      removeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        fileInput.value = '';
        if (hiddenPhotoProp) hiddenPhotoProp.value = '';
        if (previewBox) previewBox.style.display = 'none';
        if (dropzone) dropzone.style.display = 'block';
      });
    }
  }
}
